<template>
  <dr-wrapper v-if="chartKey && isInEditorMode" v-bind="$props" v-on="wrapOn">
    <dr-chart-canvas-editor 
      :chartKey="chartKey" 
      :height="height"
      :class="evaluateClasses(classes)" 
    />
  </dr-wrapper>
  <canvasjs v-else-if="chartKey && !isInEditorMode && isVisible" 
    :chartKey="chartKey" 
    :chartOptions="chart" 
    :height="height"
    :class="evaluateClasses(classes)"
  />
</template>

<script>
import mixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'
import widgetsWrapperMixin from '../../mixins/widgets-wrapper-mixin'

export default {
  mixins: [mixin, inputMixin, widgetsWrapperMixin],
  components: {
    canvasjs: () => import('./canvasjs.vue'),
    drChartCanvasEditor: () => import('./dr-chart-canvas-editor.vue')
  },
  computed: {
    chart() {
      return this.getDataSourceField(this.model.Chart) || {}
    },
    height() {
      return this.model.Height
    },
    chartKey() {
      let t = this.model.$ID  ? 
        'chartCanvas' + this.model.$ID 
        : null
      return t
    }
  }
}
</script>
